module.exports = __webpack_public_path__ + "img/shrimp.ccd35a5f.png";